module.exports = __webpack_public_path__ + "static/media/official.d5526088.svg";